import { Component, OnDestroy, Renderer, OnInit, NgZone } from '@angular/core';

import { NgIf } from '@angular/common';

import { ServiciosWebServiceProvider } from './providers/web-service-service/servicios-web-service';
import { AuthenticationService } from './providers/authentication/authentication.service';
import { LoginDTO } from './domain/dto/loginDto';

import { Message } from 'primeng/primeng';

// Necesario para mostrar mensajes con esta plantilla

import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute, NavigationStart } from '@angular/router';

// Cargamos el import del servicio de traducción de la librería
import {TranslateService} from 'ng2-translate';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Constantes } from './domain/constantes';

import {Title} from "@angular/platform-browser";

// Por default dejamos el inglés
const defaultLanguage = 'es';
// Y como adicional el español
const additionalLanguages = ['es', 'en', 'ca', 'gl'];
// Combinamos las traducciones disponibles al default.
const languages: string[] = [defaultLanguage].concat(additionalLanguages);

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy, OnInit {

	title = 'Everpaths';

	menuClick: boolean;

	menuButtonClick: boolean;

	topbarMenuButtonClick: boolean;

	topbarMenuClick: boolean;

	topbarMenuActive: boolean;

	activeTopbarItem: Element;

	layoutStatic = true;

	sidebarActive: boolean;

	mobileMenuActive: boolean;

	darkMenu: boolean;

	isRTL: boolean;

	rippleInitListener: any;

	rippleMouseDownListener: any;

	logado: boolean;

	model: LoginDTO;

	msgs: any[];

	loading: boolean;

	color: string;
	mode: string;

	mostrarMenu: boolean = false;
	menuPlegado: boolean = false;
	timerAuth: any = null;

	formLogin: FormGroup;

	link: HTMLLinkElement = document.querySelector('link[rel="icon"]');

	constructor(
		public renderer: Renderer,
		private translate: TranslateService,
		public zone: NgZone,
		public sws: ServiciosWebServiceProvider,
		public authService: AuthenticationService,
		private router: Router,
		private titleService: Title
		) {
		console.log('*** appComponent ***');
		this.loading = false;
		this.color = 'primary';
		this.mode = 'indeterminate';
		this.model = new LoginDTO();

		router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				console.log('NavigationStart');
				const estoy = router.url;
				const voy = event.url;

				console.log('  - Estoy en: ' + estoy);
				console.log('  - Voy a: ' + voy);

				this.mostrarMenu = !this.ocultarMenus();

				if (voy === '/contenidos' && estoy.indexOf('/contenidos/editar;id=') === -1){
					this.authService.resetFiltroContenido();
				}
				this.authService.NewToken();
			}
			// NavigationEnd
			// NavigationCancel
			// NavigationError
			// RoutesRecognized
		});

		if (this.timerAuth) {
			this.timerAuth.cancel();
		}
		this.timerAuth = setInterval(() => {
			
			this.authService.redirigirNoLogado();
			
	  	}, 15000);

	}

	ocultarMenus(){
		const logado = this.authService.isAuthenticated();
		return !logado;
	}

	ngOnInit() {
		window.scroll(0, 0);
		this.mostrarMenu = !this.ocultarMenus();
		this.titleService.setTitle(Constantes.TITLE);
		this.changeIcon();

		this.formLogin = new FormGroup({
			'entidad': new FormControl('', [
				Validators.required,
				Validators.minLength(3)
			]),
			'user': new FormControl('', [
				Validators.required,
				Validators.minLength(3)
			]),
			'pass': new FormControl('', [
				Validators.required,
				Validators.minLength(3)
			])
		});

        // Asignamos el lenguaje predefinido y los disponibles
        this.translate.setDefaultLang(defaultLanguage);
        this.translate.addLangs(additionalLanguages);
        // Nos basamos en el lenguaje del navegador para cambiar el lenguaje
        let initLang = this.translate.getBrowserLang();
        if (languages.indexOf(initLang) === -1) {
            initLang = defaultLanguage;
        }
        // En base a lo anterior asignamos el lenguaje a usar
        this.translate.use(initLang);

		this.zone.runOutsideAngular(() => { this.bindRipple(); });
	}

	changeIcon() {
        this.link.href = Constantes.ICON;
    };

	bindRipple() {
		this.rippleInitListener = this.init.bind(this);
		document.addEventListener('DOMContentLoaded', this.rippleInitListener);
	}

	init() {
		this.rippleMouseDownListener = this.rippleMouseDown.bind(this);
		document.addEventListener('mousedown', this.rippleMouseDownListener, false);
	}

	rippleMouseDown(e) {
		for (let target = e.target; target && target !== this; target = target['parentNode']) {
			if (!this.isVisible(target)) {
				continue;
			}

			// Element.matches() -> https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
			if (this.selectorMatches(target, '.ripplelink, .ui-button')) {
				const element = target;
				this.rippleEffect(element, e);
				break;
			}
		}
	}

	selectorMatches(el, selector) {
		const p = Element.prototype;
		const f = p['matches'] || p['webkitMatchesSelector'] || p['mozMatchesSelector'] || p['msMatchesSelector'] || function (s) {
			return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
		};
		return f.call(el, selector);
	}

	isVisible(el) {
		return !!(el.offsetWidth || el.offsetHeight);
	}

	rippleEffect(element, e) {
		if (element.querySelector('.ink') === null) {
			const inkEl = document.createElement('span');
			this.addClass(inkEl, 'ink');

			if (this.hasClass(element, 'ripplelink')) {
				element.querySelector('span').insertAdjacentHTML('afterend', '<span class=\'ink\'></span>');
			} else {
				element.appendChild(inkEl);
			}
		}

		const ink = element.querySelector('.ink');
		this.removeClass(ink, 'ripple-animate');

		if (!ink.offsetHeight && !ink.offsetWidth) {
			const d = Math.max(element.offsetWidth, element.offsetHeight);
			ink.style.height = d + 'px';
			ink.style.width = d + 'px';
		}

		const x = e.pageX - this.getOffset(element).left - (ink.offsetWidth / 2);
		const y = e.pageY - this.getOffset(element).top - (ink.offsetHeight / 2);

		ink.style.top = y + 'px';
		ink.style.left = x + 'px';
		ink.style.pointerEvents = 'none';
		this.addClass(ink, 'ripple-animate');
	}
	hasClass(element, className) {
		if (element.classList) {
			return element.classList.contains(className);
		} else {
			return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
		}
	}

	addClass(element, className) {
		if (element.classList) {
			element.classList.add(className);
		} else {
			element.className += ' ' + className;
		}
	}

	removeClass(element, className) {
		if (element.classList) {
			element.classList.remove(className);
		} else {
			element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	}

	getOffset(el) {
		const rect = el.getBoundingClientRect();

		return {
			top: rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
			left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0),
		};
	}

	unbindRipple() {
		if (this.rippleInitListener) {
			document.removeEventListener('DOMContentLoaded', this.rippleInitListener);
		}
		if (this.rippleMouseDownListener) {
			document.removeEventListener('mousedown', this.rippleMouseDownListener);
		}
	}

	ngOnDestroy() {
		this.unbindRipple();
	}

	onWrapperClick() {
		if (!this.menuClick && !this.menuButtonClick) {
			this.mobileMenuActive = false;
		}

		if (!this.topbarMenuClick && !this.topbarMenuButtonClick) {
			this.topbarMenuActive = false;
			this.activeTopbarItem = null;
		}

		this.menuClick = false;
		this.menuButtonClick = false;
		this.topbarMenuClick = false;
		this.topbarMenuButtonClick = false;
	}

	onMenuButtonClick(event: Event) {
		this.menuButtonClick = true;

		if (this.isMobile()) {
			this.mobileMenuActive = !this.mobileMenuActive;
		}

		event.preventDefault();
	}

	onTopbarMobileMenuButtonClick(event: Event) {
		this.topbarMenuButtonClick = true;
		this.topbarMenuActive = !this.topbarMenuActive;
		event.preventDefault();
	}

	onTopbarRootItemClick(event: Event, item: Element) {
		if (this.activeTopbarItem === item) {
			this.activeTopbarItem = null;
		} else {
			this.activeTopbarItem = item;
		}

		event.preventDefault();
	}

	onTopbarMenuClick(event: Event) {
		this.topbarMenuClick = true;
	}

	onSidebarClick(event: Event) {
		this.menuClick = true;
	}

	onToggleMenuClick(event: Event) {
		this.layoutStatic = !this.layoutStatic;
	}

	isMobile() {
		return window.innerWidth <= 1024;
	}

	/* AVISOS */
	hideAlert(){
		this.msgs = [];
	}

	showAlert(severity: string, mensaje: string){

		if (severity === 'error') {
			this.showError(mensaje);
		}
		else if (severity === 'info') {
			this.showInfo(mensaje);
		}
		else if (severity === 'warn') {
			this.showWarn('mensaje', mensaje);
		}
		else if (severity === 'success') {
			this.showSuccess(mensaje);
		}
		else {
			this.showError(mensaje);
		}

	}

	showError(mensaje) {
		this.msgs = [];
		this.msgs.push({ severity: 'error',  detail: mensaje });
	}

	showInfo(mensaje) {
		this.msgs = [];
		this.msgs.push({ severity: 'info',  detail: mensaje });
	}

	showSuccess(mensaje) {
		this.msgs = [];
		this.msgs.push({ severity: 'success',  detail: mensaje });
	}

	showWarn(operacion?, mensaje = '') {
		this.msgs = [];
		if (operacion === 'guardar') {
			this.msgs.push({severity: 'warn', detail: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_MODIFICAR')});
		}
		else if(operacion === 'guardarConContenidos'){
			this.msgs.push({severity: 'warn', detail: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_MODIFICAR_CONTENIDOS')});
		}
		else if (operacion === 'eliminar'){
			this.msgs.push({severity: 'warn', detail: this.translate.instant('MensajesConfirmacion.MENSAJE_CONFIRMACION_ELIMINAR')});
		}
		else if (operacion === 'mensaje'){
			this.msgs.push({severity: 'warn', detail: mensaje});
		}
		// this.msgs.push({severity: 'warn', detail: mensaje});
	}

	/* MENU LATERAL */
	ocultarMenuLateral(){
		const appMenu: HTMLElement = <HTMLElement>document.getElementsByTagName('app-menu')[0];
		if (appMenu) {
			appMenu.hidden = true;
		}
		const menu: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName('layout-wrapper')[0].getElementsByClassName('layout-main') as HTMLCollectionOf<HTMLElement>;
		menu[0].style.marginLeft = '0px';
		/*
		const topBar: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName('layout-wrapper-static')[0]
		.getElementsByClassName('layout-main')[0]
		.getElementsByClassName('layout-topbar') as HTMLCollectionOf<HTMLElement>;
		topBar[0].style.width = '100%'; // calc(100% - 240px)
		*/
	}

	mostrarMenuLateral(){
		const appMenu: HTMLElement = <HTMLElement>document.getElementsByTagName('app-menu')[0];
		if (appMenu) {
			appMenu.hidden = false;
		}

		const appMenuLayout: HTMLCollectionOf<HTMLElement> = document.getElementsByTagName('app-menu')[0].getElementsByClassName('layout-sidebar') as HTMLCollectionOf<HTMLElement>;
		if (appMenuLayout) {
			appMenuLayout[0].style.marginLeft = '0px';
		}

		const menu: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName('layout-wrapper')[0].getElementsByClassName('layout-main') as HTMLCollectionOf<HTMLElement>;
		menu[0].style.marginLeft = '240px';
		/*
		const topBar: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName('layout-wrapper-static')[0]
			.getElementsByClassName('layout-main')[0]
			.getElementsByClassName('layout-topbar') as HTMLCollectionOf<HTMLElement>;
		topBar[0].style.width = 'calc(100% - 240px)';
		*/
		this.menuPlegado = false;
	}


	plegarMenuLateral(){

		if (this.menuPlegado) {
			this.desplegarMenuLateral();
		}
		else{

			const appMenuLayout: HTMLCollectionOf<HTMLElement> = document.getElementsByTagName('app-menu')[0].getElementsByClassName('layout-sidebar') as HTMLCollectionOf<HTMLElement>;
			if (appMenuLayout) {
				appMenuLayout[0].style.marginLeft = '-170px';
			}

			const menu: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName('layout-wrapper')[0].getElementsByClassName('layout-main') as HTMLCollectionOf<HTMLElement>;
			menu[0].style.marginLeft = '70px';
			/*
			const topBar: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName('layout-wrapper-static')[0]
			.getElementsByClassName('layout-main')[0]
			.getElementsByClassName('layout-topbar') as HTMLCollectionOf<HTMLElement>;
			topBar[0].style.width = 'calc(100% - 70px)';
			*/
			this.menuPlegado = true;
		}

	}

	desplegarMenuLateral(){
		this.mostrarMenuLateral();
	}

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/app.component.ts